import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import { ConfigForm } from '../components/configs/ConfigForm';
import { useCreateCollaborationConfig } from '../hooks/useCollaborationConfigs';

export default function NewConfigPage() {
  const navigate = useNavigate();
  const createConfig = useCreateCollaborationConfig();

  const handleSubmit = async (data: {
    name: string;
    description?: string;
    definition: Record<string, unknown>;
    input?: Record<string, unknown>;
    output?: Record<string, unknown>;
    outputMapping?: Record<string, string>;
  }) => {
    await createConfig.mutateAsync(data);
    navigate('/configs');
  };

  return (
    <div>
      <PageHeader
        title="New Config"
        description="Create a new collaboration configuration"
      />
      <div className="mt-6">
        <ConfigForm onSubmit={handleSubmit} mode="create" />
      </div>
    </div>
  );
}
